export default "__VITE_ASSET__C3335w44__"